/*
 * Copyright (c) Fing. All rights reserved.
 */

import React from 'react';
import {MetaTags} from "react-meta-tags";
import intl from 'react-intl-universal';

export function renderDefaultMetaTags() {

    return renderMetaTags(intl.get('metatag_title'), intl.get('metatag_descr'), "https://cdn.fing.io/images/isp/general/fing_isp_card.png");
}

export function renderDefaultMetaTagsWithTitle(title) {

    return renderMetaTags(title, intl.get('metatag_descr'), "https://cdn.fing.io/images/isp/general/fing_isp_card.png");
}

export function renderMetaTagsWithDefImg(title,descr) {

    return renderMetaTags(title, descr,
                            "https://cdn.fing.io/images/isp/general/fing_isp_card.png");
}


export function renderMetaTags(title, description, image) {
        // <meta property="og:url" content="https://internet.fing.com" />
        // <meta property="og:site_name" content="Fing Internet and Outages" />

        return (
            <MetaTags>
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta itemProp="name" content={title} />
                <meta itemProp="description" content={description} />
                <meta itemProp="image" content={image} />


                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content={image} />

                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:description" content={title} />
                <meta name="twitter:title" content={description} />
                <meta name="twitter:image" content={image} />

                <meta name="twitter:site" content="@outagedetect" />
                <meta name="twitter:creator" content="@fingapp" />
                <meta name="twitter:domain" content="internet.fing.com" />

            </MetaTags>
        );
    }

export function renderMetaTagsForDevrecog() {
    let title = "Fing Device Recognition: try now!";
    let description = "Fing Device Intelligence technology recognises devices (brand, model, category, operating system, mac vendor) based on its network attributes: MAC address, DHCP fingerprint, User-Agent, UPnP, Bonjour, Netbios, SNMP information.";
    let image = "https://www.fing.com/images/uploads/banners/MAIN_BANNER_1122x1028px_REV_SEPT_4.png";
        return (
            <MetaTags>
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta itemProp="name" content={title} />
                <meta itemProp="description" content={description} />
                <meta itemProp="image" content={image} />

                <meta property="og:url" content="https://recog.fing.com" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                <meta property="og:site_name" content="Fing Device Recognition" />

                <meta property="og:description" content={description} />
                <meta property="og:image" content={image} />

                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:description" content={title} />
                <meta name="twitter:title" content={description} />
                <meta name="twitter:image" content={image} />

                <meta name="twitter:site" content="@fingapp" />
                <meta name="twitter:creator" content="@fingapp" />
                <meta name="twitter:domain" content="recog.fing.com" />

            </MetaTags>
        );
    }

export function renderMetaTagsForFingpedia(title, description, image) {
    if (!description)
        description = "Fingpedia: the live catalog of connected devices";
    return (
        <MetaTags>
            <title>{title}</title>
            <meta name="description" content={description} />

            <meta itemProp="name" content={title} />
            <meta itemProp="description" content={description} />
            <meta itemProp="image" content={image} />

            <meta property="og:url" content="https://fingpedia.com" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:site_name" content="Fingpedia" />

            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:description" content={title} />
            <meta name="twitter:title" content={description} />
            <meta name="twitter:image" content={image} />

            <meta name="twitter:site" content="@fingapp" />
            <meta name="twitter:creator" content="@fingapp" />
            <meta name="twitter:domain" content="fingpedia.com" />

        </MetaTags>
    );
}

export function renderMetaTagsForFingHelp(title,description) {
    let image = "https://www.fing.com/images/uploads/news/INTERNET_SPEEDS_580x510.png";
    //let image = "https://www.fing.com/images/uploads/general/IMAGE_TEXT_STRIP_575x493px.png";
        return (
            <MetaTags>
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta itemProp="name" content={title} />
                <meta itemProp="description" content={description} />
                <meta itemProp="image" content={image} />

                <meta property="og:url" content="https://ticket.fing.com" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                <meta property="og:site_name" content="Fing Help" />

                <meta property="og:description" content={description} />
                <meta property="og:image" content={image} />

                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:description" content={title} />
                <meta name="twitter:title" content={description} />
                <meta name="twitter:image" content={image} />

                <meta name="twitter:site" content="@fingapp" />
                <meta name="twitter:creator" content="@fingapp" />
                <meta name="twitter:domain" content="ticket.fing.com" />

            </MetaTags>
        );
    }